/*! rb-cookie-hold-v1 — keep the Consentmo cookie notice off screen until the age gate is accepted.
 *
 * Why this is JS and not CSS. assets/rb-age-gate.css carried
 *
 *     html.rb-age-gate-open csm-cookie-consent { display: none !important; }
 *
 * which could never work. <csm-cookie-consent> styles itself from an important :host rule inside
 * its own shadow root, and per CSS Scoping the inner tree wins for important declarations, so the
 * page's rule loses no matter how it is written. assets/rb-crawler.js already documents this and
 * takes the only route that works — removing the element — which is what this file does too.
 *
 * The node is detached rather than destroyed, along with where it came from, so acceptance can put
 * the original element back. Re-showing by calling Consentmo.openDialog() instead is what produced
 * the double-banner noted in rb-age-gate.js.
 *
 * Nothing is held for crawlers (rb-crawler.js strips the banner outright and no gate is shown) or
 * for visitors who already passed the gate, since for them the notice should behave normally.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'rb_age_verified';
  var SELECTOR = 'csm-cookie-consent, .csm-cmp-root';

  /* Shared with rb-age-gate.js via rb-age-verify.js, which owns the 90-day TTL. If the two
     disagreed about who is verified, a returning visitor would have the notice held until the
     gate closed it — a flash rather than a break, but avoidable. */
  function verified() {
    if (window.rbAgeVerify) return window.rbAgeVerify.isVerified();
    try {
      return !!window.localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return false;
    }
  }

  if (window.rbIsCrawler || verified()) return;
  if (window.__rbCookieHold) return;
  window.__rbCookieHold = true;

  var held = [];
  var observer = null;
  var released = false;

  function detach(node) {
    if (!node || node.nodeType !== 1 || !node.parentNode) return;
    /* Remember the slot so release() can restore document order rather than dumping
       the banner at the end of <body>, where the app's own positioning may not apply. */
    node.__rbParent = node.parentNode;
    node.__rbNext = node.nextSibling;
    node.parentNode.removeChild(node);
    held.push(node);
  }

  function sweep(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SELECTOR)) {
      detach(root);
      return;
    }
    if (!root.querySelectorAll) return;
    var found = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i += 1) detach(found[i]);
  }

  function release() {
    if (released) return;
    released = true;
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    for (var i = 0; i < held.length; i += 1) {
      var node = held[i];
      var parent = node.__rbParent;
      try {
        if (parent && parent.isConnected && node.__rbNext && node.__rbNext.parentNode === parent) {
          parent.insertBefore(node, node.__rbNext);
        } else if (parent && parent.isConnected) {
          parent.appendChild(node);
        } else {
          document.body.appendChild(node);
        }
      } catch (err) {
        try {
          document.body.appendChild(node);
        } catch (err2) {
          /* nothing further to try — the banner stays down rather than throwing */
        }
      }
    }
    held.length = 0;
  }

  window.rbReleaseCookieBanner = release;
  document.addEventListener('rb:age-gate-closed', release);

  if (document.documentElement) sweep(document.documentElement);

  try {
    observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i += 1) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j += 1) sweep(added[j]);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (err) {
    /* Without an observer the initial sweep still covers anything already mounted. */
  }

  /* Failsafe. Holding the notice forever would suppress a consent prompt the store is
     obliged to show, so if no age gate is present to accept — snippet removed, render
     failure, anything — stop holding as soon as the document is parsed. */
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('rb-age-gate')) release();
  });
})();
